import { ReactElement } from "react";
import {
  Box,
  Text,
  HStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
} from "@chakra-ui/react";
import { BsQuestionCircleFill } from "react-icons/bs";
import { useModifiedTranslation } from "../../../hooks/useModifiedTranslation";
import { useColorToken } from "../../../hooks/useColorToken";

export function StenReferenceMarker(): ReactElement {
  return ReferenceMarker("Graph.tooltipBody.reference.sten");
}

export function MentalActivityReferenceMarker(): ReactElement {
  return ReferenceMarker("Graph.tooltipBody.reference.mentalActivity");
}

/*
 * 「参考値」のツールチップ表示
 */
function ReferenceMarker(tooltipBody: string): ReactElement {
  // 左側の「？」押下時のツールチップ表示 動作定義
  const {
    isOpen: isLeftOpen,
    onOpen: onLeftOpen,
    onClose: onLeftClose,
  } = useDisclosure();

  const t = useModifiedTranslation();
  const primaryColor = useColorToken("primary.theme_lv1");

  return (
    <>
      <Modal onClose={onLeftClose} isOpen={isLeftOpen} isCentered>
        {/* 左側の「？」押下時のツールチップ表示  */}
        <ModalOverlay />
        <ModalContent whiteSpace="unset" backgroundColor="common.base">
          <ModalCloseButton />
          <ModalHeader color="text.main_text_lv1">
            {t("Graph.tooltipTitle.reference")}
          </ModalHeader>
          <ModalBody>
            <Text
              whiteSpace="pre-wrap"
              fontWeight="100"
              color="text.main_text_lv1"
            >
              {t(tooltipBody)}
            </Text>
          </ModalBody>
        </ModalContent>
      </Modal>
      <HStack>
        <Box
          fontSize="2xs"
          fontWeight="bold"
          color="white"
          px={2}
          borderRadius="full"
          border={`thin solid ${primaryColor}`}
          bg={primaryColor}
          textAlign="center"
        >
          {t("Graph.common.reference")}
        </Box>
        <Box onClick={onLeftOpen} fontSize="xs" alignSelf="center">
          <BsQuestionCircleFill color="text.main_text_lv1" />
        </Box>
      </HStack>
    </>
  );
}
